export default function (state = 'light', action) {
    switch (action.type) {
        case "THEME_SELECTED":
            return action.payload
        default:
            return state;
    }
}
